export default __webpack_public_path__ + "static/media/linked-in.9bb0ccd4.svg";